export default (params) => ({
  trigger: {
    name: 'login.click_logout_button',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'header',
          'profile',
          'footer',
          'my_coolblue_menu',
        ],
      },
    },
    event: {
      name: 'logout',
    },
  },
});
